import React from 'react';
import PropTypes from 'prop-types';
import {Col} from 'reactstrap';
import Title from "./Title/Title";
import Conversation from "./Conversation/Conversation";
//import AdvertPreview from "./AdvertPreview/AdvertPreview";
import OperatorInfo from "./OperatorInfo/OperatorInfo";
import Notes from "./Notes/Notes";
import AdvertDetail from "components/AdvertDetail";
import IconSvg from "components/IconSvg";
import Header from "./Header/Header";
import ConversationPlaceholder from "./ConversationPlaceholder/ConversationPlaceholder";
import Statistics from "./Statistics/Statistics";

class Content extends React.Component {
    static propTypes = {
        advert: PropTypes.object,
        profileList: PropTypes.array.isRequired,
        profile: PropTypes.object,
        contacts: PropTypes.array.isRequired,
        onContactFilterChange: PropTypes.func.isRequired,
        contactFilter: PropTypes.string,
        onSaveVoiceNote: PropTypes.func.isRequired,
        onSendSms: PropTypes.func.isRequired,
        onProfileNoteFavouriteToggle: PropTypes.func.isRequired,
        notes: PropTypes.array.isRequired,
        onProfileNoteCreate: PropTypes.func.isRequired,
        onProfileNoteEdit: PropTypes.func.isRequired,
        onProfileInfoChange: PropTypes.func.isRequired,
        onProfileTitleChange: PropTypes.func.isRequired,
        onProfileConversationRead: PropTypes.func.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired,
        view: PropTypes.oneOf(['controls', 'conversation', 'notes', 'advert']),
        changeView: PropTypes.func.isRequired,
    };

    render() {
        const {
            profileList,
            profile,
            contacts,
            contactFilter,
            onContactFilterChange,
            onSaveVoiceNote,
            onSendSms,
            notes,
            onProfileNoteFavouriteToggle,
            onProfileNoteCreate,
            onProfileInfoChange,
            onProfileTitleChange,
            onProfileConversationRead,
            onProfileNoteEdit,
            onLoadMoreContacts,
            view,
            changeView,
            advert,
        } = this.props;

        const canSendSms = !!(profile && profile.advert.priceLevelText);
        const showConversation = !view || view === 'conversation';
        const showNotes = !view || view === 'notes';
        const showAdvert = !view || view === 'advert';
        const showBackArrow = ['conversation', 'notes', 'advert'].includes(view);

        return (
            <Col md={8} xl={9} className={"content conversation-content" + (profile ? " content-border" : '')}>
                {showBackArrow &&
                <a className="back" tabIndex={1} onClick={() => showConversation ? changeView('controls') : changeView('conversation')}>
                    <IconSvg id="back"/>
                </a>
                }

                {showBackArrow &&
                <Header
                    id={profile && profile.customer.customerLinks.length > 0 ? profile.customer.customerLinks[0].ident : ''}
                    page={view}
                />
                }


                {profileList.length > 0 &&
                <Title
                    onProfileCustomerInfoChange={(profile, customerInfo) => onProfileInfoChange(profile, {byCustomer: customerInfo})}
                    onProfileTitleChange={onProfileTitleChange} className={showConversation ? '' : 'd-none'}
                    profileList={profileList} profile={profile}
                />
                }

                {profileList.length > 0 &&
                <div className="row">
                    <Conversation canSendSms={canSendSms} onSaveNote={onSaveVoiceNote} contacts={contacts}
                                  onSendSms={(message) => onSendSms(profile.id, message)} id={profile ? profile.id : null}
                                  contactFilter={contactFilter} onContactFilterChange={onContactFilterChange}
                                  onRead={profile ? () => onProfileConversationRead(profile.id) : () => {
                                  }}
                                  onLoadMoreContacts={profile ? () => onLoadMoreContacts(profile.id) : () => {
                                  }}
                                  hasMore={profile && profile.numContacts > contacts.length}
                                  className={showConversation ? '' : 'd-none'} changeView={changeView} view={view}
                    />
                    <div className="col-md-4 aside pt-md-3">
                        <div>
                        {profile &&
                        <AdvertDetail advert={profile.advert} className={showAdvert ? '' : 'd-none'}/>
                        }

                        {profile &&
                        <OperatorInfo
                            onInfoChange={operatorInfo => onProfileInfoChange(profile.id, {byOperator: operatorInfo})}
                            info={profile.info.byOperator} className={showAdvert ? '' : 'd-none'}/>
                        }

                        {profile &&
                        <Statistics profile={profile} className={showAdvert ? '' : 'd-none'}/>
                        }

                        <Notes canCreateNote={!!profile} onNoteCreate={text => onProfileNoteCreate(profile.id, text)}
                               notes={notes} onFavouriteToggle={onProfileNoteFavouriteToggle}
                               onNoteEdit={onProfileNoteEdit} className={showNotes ? '' : 'd-none'}/>
                        </div>
                    </div>
                </div>
                }

                {advert && profileList.length === 0 && // No profiles to show
                    <ConversationPlaceholder advert={advert} />
                }
            </Col>
        )
    }
}

export default Content;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Content.jsx